import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-cf-stat-panel',
    templateUrl: './cf-stat-panel.component.html',
    styleUrls: ['./cf-stat-panel.component.scss'],
    imports: [CommonModule]
})
export class CfStatPanelComponent {
    @Input() label = '';
    @Input() value = '';
    @Input() style = CFStatPanelStyle.Default;
    @Input() interactive = false;
    @Input() icon?: string;
    @Output() click: EventEmitter<Event> = new EventEmitter<Event>();


    onClick(event: Event): void {
        this.click.emit(event);
        event.stopPropagation(); // Important - stop double event
    }
}

export enum CFStatPanelStyle {
    Default = "none",
    Information = "info",
    Todo = "todo",
    Done = "done",
    Warning = "warn"
}